import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";
import location from "../assets/images/location.png";
import mobile from "../assets/images/mobile.png";
import email from "../assets/images/email.png";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <img
        src="https://res.cloudinary.com/dhergugbi/image/upload/v1767425076/footer-right_oqz0sg.png"
        alt="Right Decoration"
        className="footer-img right"
      />
      <hr />
      <div className="footer-main">
        <div className="footer-about">
          <h3>
            <span className="logo-icon"></span>Sankalp Aayurveda
          </h3>
          <p>
            Our medicines are crafted using time-tested Ayurvedic ingredients
            and modern science, ensuring purity, safety, and effectiveness to
            support everyday health and long-term wellness naturally.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1CUzMcyi9d/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/_sankalp_ayurveda_?igsh=OWw1MTJuYnM2c3ds" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
        <div className="footer-links">
          <h4>Useful Links</h4>
          <ul>
            <ul className="footer-links-list">
              <li>
                <Link to="/about">About Us</Link>
              </li>
           
              <li>
                <Link to="/Contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/Authenticity">Authenticity</Link>
              </li>
            </ul>
          </ul>
        </div>
        <div className="footer-links">
          <h4> help Links</h4>
          <ul>
            <ul className="footer-links-list">
              <li>
                <Link to="/Refund-Policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/Privacy-Policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/Shipping-Policy">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/Cancellation-Policy">Cancellation Policy</Link>
              </li>
              <li>
                <Link to="/Terms-and-Conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </ul>
        </div>
        <div className="footer-contact">
          <h4>Contact Info</h4>

          <p className="contact-item">
            <img src={location} alt="location" />
            Logix Technova Sector-132, Greater Noida, Uttar Pradesh, India - 201304
          </p>

          <p className="contact-item">
            <img src={mobile} alt="mobile" />
            +91 9211710043
          </p>

          <p className="contact-item">
            <img src={email} alt="email" />
            Sankalphealth10@gmail.com
          </p>
        </div>
      </div>

      <hr />
      <p className="copyright">
        Copyright © 2026. All Right Reserved. Sankalp Aayurveda
      </p>
    </footer>
  );
};

export default Footer;
